import { Grid, Container, createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  authBg: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      display: "block",
      top: 0,
      left: -50,
      width: "100%",
      height: "100%",
      backgroundImage: `url(/images/globe_white.png)`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "500px auto",
      backgroundPositionX: "left",
    },
  },
}));

const AuthLayout = ({ children }) => {
  const { cx, classes } = useStyles();

  return (
    <Container fluid={true} p={"0"} className="h-screen">
      <Grid className="h-full" m={0}>
        <Grid.Col p={0} span={0} md={3}>
          <div
            className={cx(classes.authBg, " h-full", "w-full", "relative")}
            style={{
              background: "linear-gradient(360deg, #2BADE3 0%, #008CC6 100%)",
            }}
          ></div>
        </Grid.Col>
        <Grid.Col p={0} span={12} md={9} className="flex flex-col">
          {children}
        </Grid.Col>
      </Grid>
    </Container>
  );
};

export default AuthLayout;
